import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from 'src/app/modals/Authentication/authentication.actions';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService, private router: Router, private store: Store) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {

                if (
                    err.status === 401 
                ) {
                    // auto logout if 401 response returned from api
                    this.store.dispatch(logout());
                }
                else if (err) { 
                    
                }
                const error = err.error.message || err.statusText;
                return throwError(error);
            })
        )
    }
}
